export interface Article {
  id: string;
  slug: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  date: string;
  author: string;
  tags: string[];
  views: number;
  comments: number;
  featured: boolean;
}

export interface Category {
  name: string;
  slug: string;
  description: string;
  icon: string;
  imageUrl: string;
  count: number;
}

export const categories: Category[] = [
  {
    name: '网红塌房',
    slug: 'wanghong-tafang',
    description: '网红翻车、人设崩塌、私生活黑料全纪录，第一时间掌握网红圈最新塌房动态',
    icon: 'ri-user-unfollow-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20atmosphere%20with%20cracked%20smartphone%20screen%20showing%20social%20media%20profile%2C%20dramatic%20red%20and%20black%20lighting%2C%20glitch%20effects%2C%20cyberpunk%20aesthetic%2C%20broken%20digital%20identity%2C%20high%20contrast%2C%20cinematic%20noir%20style%2C%20dark%20background%20with%20subtle%20red%20accents%2C%20mysterious%20and%20tense%20mood&width=800&height=600&seq=cat-wanghong-01&orientation=landscape',
    count: 128,
  },
  {
    name: '明星泄露',
    slug: 'mingxing-xielou',
    description: '明星聊天记录泄露、私密对话曝光，还原娱乐圈最真实的背后故事与隐秘关系',
    icon: 'ri-chat-smile-2-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20chat%20conversation%20bubbles%20floating%20in%20void%2C%20purple%20and%20red%20neon%20glow%2C%20leaked%20messages%20aesthetic%2C%20smartphone%20with%20private%20messages%20on%20screen%2C%20dramatic%20lighting%2C%20noir%20mystery%20style%2C%20dark%20background%20with%20subtle%20texture%2C%20cinematic%20composition&width=800&height=600&seq=cat-mingxing-01&orientation=landscape',
    count: 96,
  },
  {
    name: '博主反差',
    slug: 'bozhu-fancha',
    description: '博主台前幕后反差对比，揭秘镜头前后的真实面目，反差视频与截图全收录',
    icon: 'ri-contrast-2-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Split%20screen%20contrast%20between%20glamorous%20and%20casual%20lifestyle%2C%20dark%20cinematic%20lighting%2C%20mask%20and%20reality%20concept%2C%20dual%20personality%20visual%2C%20red%20and%20purple%20split%20tone%2C%20mysterious%20dramatic%20atmosphere%2C%20dark%20background%2C%20high%20contrast%20editorial%20style&width=800&height=600&seq=cat-bozhu-01&orientation=landscape',
    count: 85,
  },
];

export const articles: Article[] = [
  {
    id: '1',
    slug: 'top-streamer-house-collapse-livestream-scandal',
    title: '某千万粉丝游戏主播深夜直播翻车，聊天记录曝光疑似涉及多人暧昧',
    summary: '拥有超过两千万粉丝的知名游戏主播在深夜直播时意外暴露微信聊天界面，多条与不同女性的暧昧对话被截图疯传，粉丝后援会紧急发声明。',
    content: '据知情人士透露，该主播当时正在进行日常游戏直播，在切换屏幕时不慎将微信聊天界面投射到了直播画面中。画面虽然只持续了不到三秒钟，但被眼尖的水友迅速截图。截图显示该主播与至少四位不同女性保持着亲密聊天关系，内容涉及约会安排、暧昧称呼以及私人话题。\n\n事件发生后，该主播的直播间在十分钟内涌入超过五十万观众，弹幕量瞬间爆表。主播在意识到问题后立即关闭了直播，但截图已经在各大社交平台疯狂传播。\n\n其所属的MCN机构在次日凌晨发布声明称"正在核实相关情况"，但未对聊天记录的真实性做出明确回应。粉丝后援会则在微博发布长文，呼吁外界"理性看待主播私人生活"。\n\n业内人士分析称，这可能是今年以来游戏直播圈影响力最大的一次塌房事件。该主播此前一直以"单身专注事业"的人设吸引粉丝，此次曝光的内容与其公开形象形成强烈反差。\n\n截至目前，该主播的社交媒体账号已设置为私密状态，所有已发布的视频内容均不可见。各大品牌方也在紧急评估是否继续与该主播的商业合作。',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20gaming%20streamer%20room%20with%20dramatic%20red%20lighting%2C%20multiple%20monitors%20showing%20glitched%20chat%20messages%2C%20cyberpunk%20noir%20aesthetic%2C%20broken%20stream%20overlay%2C%20dramatic%20shadow%20play%2C%20tense%20atmosphere%2C%20dark%20room%20with%20neon%20accents%2C%20cinematic%20lighting%2C%20mysterious%20vibe&width=1200&height=600&seq=article-1-hero&orientation=landscape',
    date: '2026-07-06',
    author: '吃瓜前线',
    tags: ['游戏主播', '直播翻车', '聊天记录', '塌房', 'MCN机构'],
    views: 289000,
    comments: 12450,
    featured: true,
  },
  {
    id: '2',
    slug: 'actress-private-chat-leaked-reveals-industry-secrets',
    title: '某一线女演员私密聊天记录泄露，揭露娱乐圈选角潜规则与片酬内幕',
    summary: '一组据称来自某当红女演员手机的微信聊天记录在网络上流传，内容涉及选角内定、片酬分配不均以及多位圈内人士的私下评价。',
    content: '这组聊天记录最早出现在某匿名论坛，随后迅速扩散至微博、豆瓣等平台。对话内容据称发生于该女演员与她的经纪人之间，时间跨度从2025年至2026年。\n\n聊天记录中详细讨论了某热门IP改编剧的选角过程，透露女主角人选早在公开试镜前就已内定。此外，对话中还涉及片酬分配的"行业惯例"，包括"阴阳合同"的具体操作方式。\n\n更为劲爆的是，该女演员在对话中对多位圈内同行进行了私下评价，包括对某男演员演技的犀利吐槽，以及对某导演私生活的描述。这些内容被截图传播后，在娱乐圈引发连锁反应。\n\n截至目前，已有两位在聊天记录中被提及的艺人通过工作室发表声明，表示将"保留追究法律责任的权利"。而涉事女演员方面则保持沉默，其工作室电话一直处于无人接听状态。\n\n法律界人士指出，如果聊天记录确为真实，泄露他人隐私的行为可能涉及违法。而对于聊天内容中涉及的可能违法违规行为，有关部门或将介入调查。',
    category: '明星泄露',
    categorySlug: 'mingxing-xielou',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20smartphone%20screen%20with%20Chinese%20chat%20messages%20glowing%20in%20darkness%2C%20purple%20and%20red%20neon%20ambient%20light%2C%20mysterious%20noir%20film%20aesthetic%2C%20dramatic%20shadows%2C%20cinematic%20movie%20set%20background%20blurred%2C%20high%20contrast%2C%20tense%20atmosphere&width=1200&height=600&seq=article-2-hero&orientation=landscape',
    date: '2026-07-05',
    author: '圈内老炮',
    tags: ['女演员', '聊天记录', '选角潜规则', '片酬', '娱乐圈'],
    views: 356000,
    comments: 18920,
    featured: true,
  },
  {
    id: '3',
    slug: 'beauty-blogger-real-appearance-exposed',
    title: '美妆博主线下活动生图流出，与精修自拍判若两人，粉丝直呼被骗',
    summary: '某拥有五百万粉丝的美妆博主在参加品牌线下活动时被粉丝拍到未修生图，与日常发布的精修自拍形成巨大反差，引发粉丝信任危机。',
    content: '该美妆博主此前一直以"素颜女神"的人设吸引粉丝，日常发布的照片和视频中皮肤状态极佳，五官精致立体。然而，上周末参加某国际美妆品牌的线下新品发布会时，被现场粉丝用手机拍摄的多张"生图"在社交平台流传开来。\n\n对比照片显示，该博主的真实皮肤状态与精修图存在明显差距，面部轮廓也与自拍中的V字脸有明显区别。有网友将博主自己发布的精修图与现场生图并列对比，两者差异之大令人瞠目。\n\n事件发酵后，该博主在微博发文回应称"每个人都有状态好和不好的时候"，并指责拍摄者"恶意抓拍"。然而评论区并未如其所愿站在她这边，大量粉丝表示"不是状态问题，是完全换了个人"。\n\n美妆业内人士表示，过度修图在美妆博主圈已是普遍现象，但此次事件中前后差异确实过大，已经触及了粉丝容忍的底线。该品牌方也受到波及，被质疑"选人标准有问题"。\n\n截至目前，该博主的抖音账号已经关闭评论功能，其带货的多款美妆产品也出现了大量退货。',
    category: '博主反差',
    categorySlug: 'bozhu-fancha',
    imageUrl: 'https://readdy.ai/api/search-image?query=Split%20face%20comparison%20concept%2C%20dark%20moody%20lighting%2C%20makeup%20mirror%20with%20cracked%20reflection%2C%20glamorous%20versus%20natural%20contrast%2C%20red%20and%20blue%20dual%20tone%2C%20cinematic%20noir%20style%2C%20beauty%20products%20scattered%2C%20dramatic%20shadows%2C%20mysterious%20atmosphere&width=1200&height=600&seq=article-3-hero&orientation=landscape',
    date: '2026-07-04',
    author: '真相挖掘机',
    tags: ['美妆博主', '生图', '修图', '反差', '信任危机'],
    views: 198000,
    comments: 8760,
    featured: false,
  },
  {
    id: '4',
    slug: 'fitness-influencer-doping-scandal',
    title: '健身博主私下药物清单曝光，完美身材背后竟靠违禁药物支撑',
    summary: '某知名健身博主因与健身房教练发生纠纷，被对方曝光了其私下使用的药物清单，包括多种增肌类固醇和减肥药物。',
    content: '该健身博主在社交平台拥有超过三百万粉丝，以"自然健身""健康生活"为标签打造人设，曾多次在视频中强调自己"从不使用任何药物"。其带货的蛋白粉、运动补剂销售额长期位居品类前列。\n\n然而，与其合作过的一位私教教练因薪资纠纷，在朋友圈曝光了一份详细的药物使用清单和购买记录。清单中包含多种增肌类固醇、生长激素以及处方减肥药物，购买记录显示这些药物的花费每月高达数万元。\n\n更令人震惊的是，曝光内容中还包含该博主指导学员使用违禁药物的聊天记录，涉及多位付费学员。这一细节让事件从个人诚信问题升级为潜在的公共安全事件。\n\n该博主在事件曝光后发布视频否认一切指控，声称"清单是伪造的"，并表示已报警处理。但多位曾接受其指导的学员站出来证实了聊天记录的真实性。\n\n体育监管部门表示已关注此事，如查实该博主确实引导他人使用违禁药物，将面临行政处罚甚至刑事责任。',
    category: '博主反差',
    categorySlug: 'bozhu-fancha',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20gym%20interior%20with%20dramatic%20red%20lighting%2C%20medicine%20bottles%20and%20syringes%20scattered%20on%20floor%2C%20broken%20mirror%20reflection%2C%20mysterious%20noir%20style%2C%20fitness%20equipment%20in%20shadows%2C%20tense%20atmosphere%2C%20cinematic%20composition%2C%20dark%20background&width=1200&height=600&seq=article-4-hero&orientation=landscape',
    date: '2026-07-03',
    author: '体育观察员',
    tags: ['健身博主', '违禁药物', '类固醇', '人设崩塌', '学员'],
    views: 245000,
    comments: 11230,
    featured: false,
  },
  {
    id: '5',
    slug: 'singer-wechat-records-reveal-tax-evasion',
    title: '歌手前助理曝光三年聊天记录，揭示天价演出背后的逃税黑幕',
    summary: '一位自称曾担任某知名歌手私人助理三年的网友，在网上发布了近百页的聊天记录截图，内容涉及阴阳合同、虚假发票和境外转移资产。',
    content: '该助理在社交媒体上发布长文称"忍无可忍，无需再忍"，并附上了大量与歌手的微信聊天记录、银行转账截图以及合同照片。资料显示，这位歌手在过去三年中通过"阴阳合同"的方式，将大量演出收入以现金形式收取，规避个人所得税。\n\n聊天记录中还曝光了该歌手通过境外公司虚构咨询服务费的方式将资金转移至海外账户的细节。助理称，仅在2025年，该歌手就通过这种方式转移了超过两千万的收入。\n\n此外，曝光内容还涉及该歌手与合作品牌方的私下交易，包括收取品牌方"返点"却不申报纳税的行为。这些内容如果属实，将涉及严重的税务违法行为。\n\n税务部门已注意到相关网络信息，表示将"依法依规处理"。该歌手工作室发布声明称"网络流传内容严重失实"，并表示已委托律师处理。\n\n娱乐圈税务问题近年来一直是社会关注的焦点，此次事件再次将明星税务合规问题推上风口浪尖。',
    category: '明星泄露',
    categorySlug: 'mingxing-xielou',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20office%20with%20financial%20documents%20scattered%2C%20red%20ledger%20books%20under%20dramatic%20lighting%2C%20contracts%20and%20money%20in%20shadows%2C%20noir%20investigation%20aesthetic%2C%20mysterious%20corporate%20espionage%20vibe%2C%20dark%20background%2C%20cinematic%20lighting&width=1200&height=600&seq=article-5-hero&orientation=landscape',
    date: '2026-07-02',
    author: '财经调查局',
    tags: ['歌手', '逃税', '阴阳合同', '助理', '税务', '境外资产'],
    views: 421000,
    comments: 21540,
    featured: true,
  },
  {
    id: '6',
    slug: 'food-blogger-fake-eating-exposed',
    title: '吃播博主假吃翻车现场，后期剪辑师离职后曝光造假全过程',
    summary: '某吃播博主的后期剪辑师因被拖欠工资而离职，随后在B站发布了该博主的"假吃"剪辑过程视频，揭开了大胃王吃播的造假产业链。',
    content: '该剪辑师在B站发布的视频长达四十分钟，详细展示了该吃播博主如何通过剪辑技巧制造"吃很多"的假象。原始素材显示，博主实际只吃了几口食物，其余部分通过多角度重复剪辑、食物替换和吐食镜头删除等手法，伪造出"吃完整桌菜"的效果。\n\n更令人震惊的是，该视频还揭示了制作团队如何利用"呕吐"场景。博主在录制间隙会通过催吐的方式清空胃部，以便继续录制下一段"吃播"内容。这些催吐的原始素材此前都被要求"立即删除"。\n\n该剪辑师表示，自己因连续三个月未收到工资才决定曝光真相。"我不想再帮他们骗人了，尤其是看到那么多观众真心喜欢他、给他打赏，我觉得良心受到了谴责。"\n\n视频发布后，该吃播博主的账号在一夜间掉粉超过八十万。多个品牌方紧急撤下了与该博主的合作广告。平台方也发布公告称，将对该博主的账号进行"内容真实性审查"。\n\n食品浪费问题也随之被提及。有评论指出，即使存在假吃，大量食物被浪费的事实依然存在，呼吁加强对吃播行业的监管。',
    category: '博主反差',
    categorySlug: 'bozhu-fancha',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20video%20editing%20suite%20with%20timeline%20showing%20glitched%20footage%2C%20food%20on%20table%20in%20dramatic%20lighting%2C%20red%20and%20blue%20dual%20tone%2C%20behind%20the%20scenes%20exposure%20concept%2C%20noir%20documentary%20style%2C%20mysterious%20cinematic%20composition&width=1200&height=600&seq=article-6-hero&orientation=landscape',
    date: '2026-07-01',
    author: '工薪阶层观察',
    tags: ['吃播', '假吃', '剪辑', '催吐', '食品浪费', '造假'],
    views: 312000,
    comments: 15320,
    featured: false,
  },
  {
    id: '7',
    slug: 'internet-celebrity-divorce-live-broadcast-chaos',
    title: '网红夫妻直播离婚互撕，男方突然亮出女方出轨证据引爆全网',
    summary: '一对拥有千万粉丝的网红夫妻原定在直播间"和平宣布离婚"，不料男方在直播中突然放出女方出轨的聊天记录和酒店监控截图。',
    content: '这对网红夫妻此前在社交媒体上一直以"模范夫妻"的形象示人，经常合体直播带货，年收入据估计超过五千万。上个月两人宣布将"和平分手"，并约定在周六晚八点进行最后一场合体直播。\n\n直播开始的前十分钟一切正常，两人按照剧本回顾了相识相爱到"和平分手"的历程。然而当女方说到"感谢这些年的陪伴"时，男方突然打断，表示"既然今天是最后一次了，有些东西还是让大家看看吧"。\n\n随后，男方在直播间投屏展示了多张女方与其他男性的微信聊天记录截图、酒店入住记录以及监控照片。画面显示这些证据的时间跨度长达一年半，意味着在两人对外展示"恩爱"的同时，女方一直与他人保持着婚外关系。\n\n直播间瞬间炸裂，在线观看人数从八十万飙升到三百五十万。女方当场面色惨白，试图关闭直播设备但被助理拦住。男方说完"大家好自为之"后直接起身离开。\n\n事件在各大平台持续发酵，相关话题在微博阅读量突破十亿。网友纷纷评论"这是我见过最硬核的离婚直播"。两人合作的品牌方也在紧急联系各自团队处理善后事宜。',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20livestream%20studio%20with%20dramatic%20red%20and%20blue%20lighting%2C%20split%20screen%20showing%20couple%20argument%2C%20glitch%20effects%2C%20phone%20screen%20with%20messages%2C%20tense%20atmosphere%2C%20noir%20reality%20show%20aesthetic%2C%20dramatic%20shadows%2C%20cinematic%20composition&width=1200&height=600&seq=article-7-hero&orientation=landscape',
    date: '2026-06-30',
    author: '婚姻观察室',
    tags: ['网红夫妻', '直播离婚', '出轨', '互撕', '证据曝光'],
    views: 589000,
    comments: 32450,
    featured: true,
  },
  {
    id: '8',
    slug: 'celebrity-manager-exposes-contract-fraud',
    title: '经纪人离职后猛料连发，曝光顶流艺人阴阳合同与天价违约金内幕',
    summary: '某顶流艺人的前经纪人因被无故解雇，在社交媒体连发数十条爆料，涉及阴阳合同、天价违约金条款以及对粉丝的私下恶劣评价。',
    content: '该经纪人在长文中披露，这位表面温文尔雅的顶流艺人私下对待工作人员极为苛刻。聊天记录显示，该艺人曾因为化妆师迟到了五分钟而当众辱骂对方，并在事后要求经纪公司将其开除。\n\n更具爆炸性的是合同细节。该经纪人展示了艺人与某综艺节目签订的"阴阳合同"——公开合同显示出场费为每期两百万，但私下的补充协议中实际金额为每期八百万元，差额部分通过境外公司以"版权费"名义支付，完全规避了中国的税收监管。\n\n此外，该经纪人还曝光了艺人与粉丝后援会会长的私密聊天，内容显示该艺人多次通过后援会向粉丝收取"应援费"，用于购买奢侈品和私人旅行，这些费用从未对外公开。\n\n该艺人的工作室在爆料发出三小时后发布声明，全盘否认所有指控，并称前经纪人"因被合理辞退而怀恨在心"。但网友们发现，该声明中对"阴阳合同"的具体细节避而不谈。\n\n截至发稿时，已有多个品牌宣布"暂停与该艺人的合作关系"。据悉，相关部门也已介入调查。',
    category: '明星泄露',
    categorySlug: 'mingxing-xielou',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20luxury%20office%20with%20gold%20accents%20and%20documents%20scattered%2C%20dramatic%20red%20lighting%2C%20contract%20papers%20floating%2C%20broken%20pen%2C%20mysterious%20corporate%20noir%20aesthetic%2C%20cinematic%20composition%2C%20tense%20atmosphere%2C%20dark%20shadows&width=1200&height=600&seq=article-8-hero&orientation=landscape',
    date: '2026-06-29',
    author: '娱乐圈纪检委',
    tags: ['顶流艺人', '经纪人', '阴阳合同', '违约金', '粉丝应援'],
    views: 467000,
    comments: 23450,
    featured: false,
  },
  {
    id: '9',
    slug: 'live-streamer-marraige-scam-exposed-by-victim',
    title: '女主播被曝同时交往多名榜一大哥，受害者联合公开转账记录',
    summary: '一名女主播的多位"榜一大哥"在私下交流后发现，该主播用相同的套路向每人索要了大量打赏和礼物，总金额超过百万。',
    content: '这起事件的导火索是一位"榜一大哥"在粉丝群中无意间提到自己给该主播转账了二十万元"应急"。没想到群里另一位大哥也表示自己也转了十五万，理由同样是"家里急用"。\n\n随后，更多的"大哥"加入了讨论。经过信息比对，他们发现该女主播在过去两年中，同时与至少六位"榜一大哥"保持着暧昧关系，并以各种理由向他们借钱或索要礼物。常见的话术包括"家里人生病需要手术费""还信用卡差一点""想做个小生意缺启动资金"等。\n\n几位受害者整理了所有的转账记录和聊天截图，制作成一份详尽的时间线文档，在某论坛发布。文档显示，该女主播从这些人手中获得的金钱和礼物总价值超过一百二十万元。\n\n该女主播最初试图狡辩称这些都是"粉丝自愿的礼物"，但在确凿的证据面前最终选择了沉默。其直播间被平台紧急关闭，账号也处于冻结状态。\n\n法律专家表示，如果证据显示该女主播存在虚构事实、骗取财物的行为，可能构成诈骗罪。据悉，已有多位受害者联合委托律师准备提起集体诉讼。',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20livestreaming%20room%20with%20floating%20red%20money%20envelopes%2C%20multiple%20smartphone%20screens%20showing%20transfer%20records%2C%20dramatic%20red%20lighting%2C%20deceptive%20atmosphere%2C%20noir%20style%2C%20dark%20background%2C%20cinematic%20composition&width=1200&height=600&seq=article-9-hero&orientation=landscape',
    date: '2026-06-28',
    author: '反诈联盟',
    tags: ['女主播', '榜一大哥', '诈骗', '转账记录', '情感套路'],
    views: 345000,
    comments: 16780,
    featured: false,
  },
  {
    id: '10',
    slug: 'knowledge-blogger-plagiarism-chain-exposed',
    title: '知识博主被扒文案全盘抄袭，三年内容竟全部搬运海外博主',
    summary: '一位以"深度思考""知识分享"走红的知识类博主，被网友发现其几乎所有视频文案都一字不差地翻译自多位海外创作者。',
    content: '该博主在B站和抖音共拥有超过六百万粉丝，以"独立思考"和"深度解读"作为个人标签，每条视频都会在开头强调"原创内容"。然而，一位精通英语的粉丝在观看某海外YouTuber的视频时，发现其内容与自己关注的中国博主惊人地相似。\n\n这位粉丝随后进行了系统性比对，结果令人震惊——该博主发布的超过两百条视频中，至少有九成的文案完全翻译自海外博主，其中包括经济学解读、心理学分析、科技评论等多个领域。更离谱的是，该博主连海外博主的口头禅和个人经历故事都照搬不误，只是在字幕中将"我"的名字换成了自己的。\n\n对比视频被制作成长达一个小时的纪录片形式发布，将每条视频的抄袭来源逐一标注。视频中有博主自己在镜头前说"这个故事是我亲身经历的"，但原始出处显示这个故事发生在美国博主身上。\n\n该博主在被曝光后发布了一条道歉视频，称自己"太想做好内容了，走了捷径"。但网友们并不买账，指出这根本不是什么"捷径"，而是系统性的诈骗行为。\n\n多个平台已对该博主的账号进行了限流处理，部分品牌合作也被终止。据悉，被抄袭的几位海外博主正在考虑通过法律途径维权。',
    category: '博主反差',
    categorySlug: 'bozhu-fancha',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20library%20with%20books%20and%20screens%2C%20copy%20paste%20concept%2C%20dual%20monitors%20showing%20identical%20content%2C%20red%20and%20purple%20dramatic%20lighting%2C%20plagiarism%20theme%2C%20noir%20documentary%20style%2C%20dark%20academic%20aesthetic%2C%20cinematic%20composition&width=1200&height=600&seq=article-10-hero&orientation=landscape',
    date: '2026-06-27',
    author: '原创保护者',
    tags: ['知识博主', '抄袭', '搬运', 'YouTube', '原创', '翻车'],
    views: 278000,
    comments: 14560,
    featured: false,
  },
  {
    id: '11',
    slug: 'dance-idol-behind-scenes-bullying-exposed',
    title: '舞蹈区UP主被多位前成员联合曝光霸凌行为，聊天记录触目惊心',
    summary: '某舞蹈区的头部UP主被曾经合作过的五位舞者联合发文曝光，指其在合作期间存在长期霸凌、剽窃编舞和克扣报酬等恶劣行为。',
    content: '这五位前合作成员在微博发布了联合声明，详细列举了与该UP主合作期间的种种遭遇。聊天记录截图显示，该UP主在群聊中对成员使用极为恶劣的语言进行人身攻击，甚至涉及外貌羞辱和家庭背景歧视。\n\n声明中还爆料，该UP主多次将团队成员的原创编舞据为己有，在发布视频时只标注自己为编舞者，对实际创作者只字不提。一位前成员表示，自己辛苦编排三个月的舞蹈作品，被该UP主在视频中标为自己的"原创"，连一个感谢都没有。\n\n在报酬方面，声明称该UP主经常以"视频还没赚钱""这次是帮忙"等理由拖欠或克扣成员的演出费和分成。但事实上，该UP主的视频广告收入每月超过十万元。\n\n该UP主在被曝光后并未道歉，反而在直播中称这些前成员是"蹭热度""过河拆桥"。这种态度进一步激怒了网友，大量粉丝在评论区表示要取关。\n\n目前该UP主的账号已掉粉超过三十万，多个正在洽谈中的品牌合作也被搁置。舞蹈圈内多位知名UP主也纷纷发声声援受害者。',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20dance%20studio%20with%20dramatic%20shadows%2C%20broken%20mirror%20reflections%2C%20red%20distress%20lighting%2C%20abandoned%20dance%20shoes%2C%20group%20conflict%20atmosphere%2C%20noir%20performance%20art%20aesthetic%2C%20cinematic%20composition%2C%20tense%20mood&width=1200&height=600&seq=article-11-hero&orientation=landscape',
    date: '2026-06-26',
    author: '舞圈观察',
    tags: ['舞蹈UP主', '霸凌', '剽窃', '克扣报酬', '联合曝光'],
    views: 201000,
    comments: 9870,
    featured: false,
  },
  {
    id: '12',
    slug: 'top-actor-secret-relationship-chat-history-leaked',
    title: '顶流男演员秘密恋情曝光，与女制片人暧昧聊天记录被黑客泄露',
    summary: '一份据称通过黑客手段获取的聊天记录在某暗网论坛流传，内容显示某已婚男演员与一位知名女制片人长期保持不正当关系。',
    content: '这份聊天记录最早出现在某海外暗网论坛，随后被网友搬运至国内平台。聊天记录时间跨度超过两年，涉及的内容包括两人的私密约会安排、对各自配偶的抱怨，以及讨论如何利用工作关系为彼此争取资源。\n\n其中一段对话显示，这位女制片人曾利用职务之便，为男演员在某重大项目中争取到了"高于市场价三倍"的片酬。而男演员则在另一项目中"指定"该女制片人担任制片，排挤掉了原定的制片团队。\n\n聊天记录中还涉及两人对多位圈内同行的私下评议，包括对某导演能力的贬低，以及对某女演员外貌的刻薄评价。这些内容如果被证实属实，将对该男演员的公众形象造成毁灭性打击。\n\n事件曝光后，该男演员的经纪团队火速发布声明，称聊天记录为"AI伪造"，并表示已向公安机关报案。但网络安全专家指出，要完全伪造如此体量且细节丰富的聊天记录，技术难度极大。\n\n该男演员的妻子是圈内知名的演员，两人育有一对儿女，一直被视为娱乐圈的"模范夫妻"。此次事件让这个完美形象出现了巨大裂痕。',
    category: '明星泄露',
    categorySlug: 'mingxing-xielou',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20luxury%20hotel%20room%20with%20smartphone%20on%20bed%2C%20glowing%20chat%20messages%20in%20darkness%2C%20dramatic%20red%20and%20purple%20lighting%2C%20secret%20affair%20atmosphere%2C%20noir%20romantic%20thriller%20aesthetic%2C%20cinematic%20composition%2C%20mysterious%20mood&width=1200&height=600&seq=article-12-hero&orientation=landscape',
    date: '2026-06-25',
    author: '暗网观察员',
    tags: ['男演员', '制片人', '婚外情', '黑客', '聊天记录', '模范夫妻'],
    views: 512000,
    comments: 28700,
    featured: true,
  },
];

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.categorySlug === categorySlug);
};

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getFeaturedArticles = (): Article[] => {
  return articles.filter((a) => a.featured);
};

export const getRelatedArticles = (currentSlug: string, limit: number = 3): Article[] => {
  const current = articles.find((a) => a.slug === currentSlug);
  if (!current) return articles.slice(0, limit);
  return articles
    .filter((a) => a.slug !== currentSlug && a.categorySlug === current.categorySlug)
    .slice(0, limit);
};

export interface UserComment {
  id: string;
  username: string;
  avatar: string;
  content: string;
  time: string;
  likes: number;
}

export const hotComments: UserComment[] = [
  {
    id: 'c1',
    username: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20dark%20avatar%20icon%2C%20mysterious%20silhouette%20with%20red%20glow%2C%20anonymous%20user%20profile%20style%2C%20dark%20background&width=64&height=64&seq=avatar-1&orientation=squarish',
    content: '这一波塌房速度也太快了，上个月还在立人设，这个月直接崩塌。娱乐圈太魔幻了！',
    time: '2小时前',
    likes: 3200,
  },
  {
    id: 'c2',
    username: '真相只有一个',
    avatar: 'https://readdy.ai/api/search-image?query=Dark%20detective%20style%20avatar%2C%20mysterious%20figure%20with%20magnifying%20glass%2C%20noir%20aesthetic%2C%20red%20accent%20lighting%2C%20dark%20background&width=64&height=64&seq=avatar-2&orientation=squarish',
    content: '看了聊天记录的内容，感觉比电视剧还精彩。建议可以直接拿去拍成网剧，收视率肯定爆。',
    time: '3小时前',
    likes: 2580,
  },
  {
    id: 'c3',
    username: '圈内知情者',
    avatar: 'https://readdy.ai/api/search-image?query=Anonymous%20dark%20avatar%20with%20shadow%20face%2C%20insider%20whistleblower%20style%2C%20purple%20and%20red%20glow%2C%20dark%20background%2C%20mysterious%20minimalist&width=64&height=64&seq=avatar-3&orientation=squarish',
    content: '我只能说，现在爆出来的可能只是冰山一角。据我了解，还有更猛的料在后面。',
    time: '5小时前',
    likes: 4210,
  },
  {
    id: 'c4',
    username: '理性吃瓜群众',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20dark%20watermelon%20slice%20icon%2C%20playful%20mysterious%20style%2C%20red%20and%20green%20minimal%2C%20dark%20background&width=64&height=64&seq=avatar-4&orientation=squarish',
    content: '搬好小板凳，备好瓜子饮料。今年的瓜田格外丰收，吃都吃不过来了。',
    time: '6小时前',
    likes: 1890,
  },
  {
    id: 'c5',
    username: '法律人小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20dark%20minimalist%20avatar%2C%20scales%20of%20justice%20icon%2C%20red%20accent%2C%20law%20theme%2C%20dark%20background&width=64&height=64&seq=avatar-5&orientation=squarish',
    content: '从法律角度看，如果这些聊天记录是真实的，那涉及的就不只是道德问题了，可能还有法律风险。',
    time: '8小时前',
    likes: 1560,
  },
];

export const aboutInfo = {
  brandName: '黑料718',
  slogan: '全网吃瓜，只在718',
  introduction: '黑料718成立于2024年，是国内领先的娱乐资讯聚合平台。我们专注于为吃瓜群众提供最新、最全、最真实的娱乐八卦和网红黑料。平台聚合了来自各大社交媒体、论坛和匿名渠道的第一手爆料信息，通过专业的编辑团队进行整理和核实，确保每一条内容的真实性和时效性。',
  mission: '我们的使命是打破信息壁垒，让每一个吃瓜群众都能第一时间获取最真实的爆料内容。我们不造谣、不传谣，只做真相的搬运工和整理者。',
  values: [
    {
      title: '真实至上',
      description: '每一条爆料内容都经过多渠道交叉验证，拒绝虚假信息，坚持还原事实真相。',
      icon: 'ri-shield-check-line',
    },
    {
      title: '速度优先',
      description: '7×24小时全天候监控全网信息，确保热点事件发生后的第一时间同步报道。',
      icon: 'ri-flashlight-line',
    },
    {
      title: '用户第一',
      description: '以吃瓜群众的需求为核心，不断优化内容呈现方式，打造极致的浏览体验。',
      icon: 'ri-heart-line',
    },
  ],
  stats: [
    { label: '累计爆料', value: '12,800+' },
    { label: '日活用户', value: '850,000+' },
    { label: '内容分类', value: '15+' },
    { label: '合作媒体', value: '200+' },
  ],
  contact: {
    email: 'hello@gjxfl.cn',
    wechat: 'heiliao718_official',
    weibo: '@黑料718官方',
    address: '中国上海市浦东新区陆家嘴金融贸易区',
  },
};

export const faqData = [
  {
    question: '黑料718的内容来源是什么？',
    answer: '黑料718的内容来源于多个渠道，包括社交媒体公开信息、用户匿名投稿、主流媒体报道以及合作媒体提供的内容。我们的编辑团队会对每一条信息进行多渠道交叉验证，确保内容的真实性和可靠性。',
  },
  {
    question: '如何下载黑料718 APP？',
    answer: '黑料718 APP目前支持iOS和Android两大平台。您可以在Apple App Store搜索"黑料718"或通过我们的官方网站扫描二维码进行下载。Android用户也可以通过各大应用商店（华为应用市场、小米应用商店等）搜索下载。',
  },
  {
    question: '黑料718的爆料内容会被删除吗？',
    answer: '我们严格遵循内容真实性原则。只有当爆料内容被证实为虚假信息，或涉及个人隐私侵权且当事人提供法律文件要求删除时，我们才会按照法定程序处理相关内容。正常的真实爆料一经发布，不会因为任何外部压力而删除。',
  },
  {
    question: '如何向黑料718投稿爆料？',
    answer: '您可以通过官网"投稿爆料"入口提交内容，hello@gjxfl.cn。我们承诺对所有投稿者信息严格保密，绝不泄露投稿人身份。对于被采纳的重要爆料，我们还会给予相应的稿酬奖励。',
  },
  {
    question: '黑料718最新地址在哪里？',
    answer: '黑料718的永久官网地址为gjxfl.cn。如遇域名变更或访问异常，请关注我们的官方微博@黑料718官方或微信公众号"黑料718"，我们将第一时间发布最新访问地址。',
  },
];

export const siteNavLinks = {
  main: [
    { name: '首页', href: '/' },
    { name: '网红塌房', href: '/category/wanghong-tafang' },
    { name: '明星泄露', href: '/category/mingxing-xielou' },
    { name: '博主反差', href: '/category/bozhu-fancha' },
    { name: '关于我们', href: '/about' },
  ],
  footer: {
    categories: [
      { name: '网红塌房', href: '/category/wanghong-tafang' },
      { name: '明星聊天记录', href: '/category/mingxing-xielou' },
      { name: '博主反差视频', href: '/category/bozhu-fancha' },
      { name: '最新爆料', href: '/category/wanghong-tafang' },
    ],
    about: [
      { name: '品牌介绍', href: '/about' },
      { name: '联系我们', href: '/about' },
      { name: '投稿爆料', href: '/about' },
      { name: '用户协议', href: '/about' },
    ],
    support: [
      { name: '常见问题', href: '/about' },
      { name: 'APP下载', href: '/about' },
      { name: '最新地址', href: '/about' },
      { name: '意见反馈', href: '/about' },
    ],
  },
};